'use client';

import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Prose } from '@osmosis/tailwind-ui/components/Prose';
import React, { useEffect, useState } from 'react';
import BlurredBlockAuth from './BlurredBlockAuth';

type Props = {
  transcript: string;
  transcriptShort: string;
  isLoggedInView: boolean;
  authText: string;
};
/**
 * TranscriptClientBlock.
 */
export default function TranscriptClientBlock({
  transcript,
  transcriptShort,
  isLoggedInView,
  authText,
}: Props) {
  const [isBlurred, setIsBlurred] = useState(false);

  useEffect(() => {
    const updateBlur = () => {
      const modalSeen = localStorage.getItem('transcriptModalSeen');
      setIsBlurred(!!modalSeen);
    };

    updateBlur();
    window.addEventListener('scroll', updateBlur);
    return () => window.removeEventListener('scroll', updateBlur);
  }, []);

  return (
    <Box className="relative">
      <Prose
        data-testid="transcript-block-content"
        content={isLoggedInView || !isBlurred ? transcript : transcriptShort}
      />
      {isBlurred && !isLoggedInView && (
        <BlurredBlockAuth text={authText} className="min-h-40" />
      )}
    </Box>
  );
}
